import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", company: "" });
  const [err, setErr] = useState(""); const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      await register(f);
      nav("/dashboard");
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <form onSubmit={submit} className="w-full max-w-md space-y-5 border border-gray-200 p-8" data-testid="register-form">
        <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-gray-500">Create account</div>
        <h2 className="text-3xl font-black tracking-tight">Join Vaku</h2>
        {[
          ["Name", "name", "text"],
          ["Email", "email", "email"],
          ["Company", "company", "text"],
          ["Password", "password", "password"],
        ].map(([label, key, type]) => (
          <div key={key}>
            <label className="text-xs font-bold uppercase tracking-wider text-gray-600 block mb-1.5">{label}</label>
            <input
              data-testid={`register-${key}`}
              type={type}
              required={key !== "company"}
              value={f[key]}
              onChange={(e) => setF({ ...f, [key]: e.target.value })}
              className="w-full border border-gray-300 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0020C2]"
            />
          </div>
        ))}
        {err && <div className="text-xs text-[#DC2626] font-semibold" data-testid="register-error">{err}</div>}
        <button
          type="submit"
          data-testid="register-submit"
          disabled={loading}
          className="w-full bg-[#0020C2] text-white py-3 text-sm font-bold uppercase tracking-wider hover:bg-[#001AA3] disabled:opacity-50"
        >
          {loading ? "Creating…" : "Create account"}
        </button>
        <div className="text-xs text-gray-500">
          Have an account? <Link to="/login" className="text-[#0020C2] font-semibold underline" data-testid="login-link">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
